import { FormOptions, useFormHookFactory } from '../../../hooks/useFormHookFactory/useFormHookFactory';

export interface SubmitValue {
  communitySupport?: string;
  contactInfo?: string;
  otherProviders?: string;
}

export const useSocialSupportForm = (options?: FormOptions) => {
  const factory = useFormHookFactory({
    communitySupport: {
      name: 'communitySupport',
      label: 'Community/Social Support',
    },
    contactInfo: {
      name: 'contactInfo',
      label: 'Contact Information',
    },
    otherProviders: {
      name: 'otherProviders',
      label: 'Other Providers',
    },
  }, options);

  return factory;
};
